
var formLess = {};
import genaration from '../../utils/classname';
export var formClass = genaration(formLess, 'form');
export var inputBorderClass = genaration(formLess, 'inputBorder');